import { useAppLoader } from '@capsicum/common';
import { useCallback } from 'react';

import { type EmailGenerateCodeParams, type WelcomeVariant } from '../models';

import { useSendVerificationCode } from './useSendVerificationCode';

export const useSendCodeByEmail = () => {
	const loader = useAppLoader();
	const { sendEmailCodeToUser, sendEmailCodeToUserOnRegistration } = useSendVerificationCode();

	return useCallback(
		({ attempt, captchaInformation, email, variant }: EmailGenerateCodeParams & { variant: WelcomeVariant }) => {
			return loader(
				(variant === 'register' ? sendEmailCodeToUserOnRegistration : sendEmailCodeToUser)({
					attempt: attempt ?? '0',
					captchaInformation,
					email
				})
			);
		},
		[loader, sendEmailCodeToUser, sendEmailCodeToUserOnRegistration]
	);
};
